/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Description = styled.div({
  fontSize: token('font.body.small', '11px'),
  color: token('color.text.subtle', colors.N200),
});

export const ChangedValueStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 'space.050',
  gap: 'space.100',
  fontSize: token('font.heading.large', '24px'),
});

export const CurrentValue = styled('div')<{ isImproved: boolean }>(
  ({ isImproved }) => ({
    color: isImproved
      ? token('color.text.accent.green', colors.G500)
      : token('color.text.accent.red', colors.R500),
  })
);

export const LozengeDifference = styled.span({
  display: 'inline-block',
  verticalAlign: 'text-bottom',
});

export const tooltipStyles = {
  color: token('color.text.inverse', colors.N0),
  backgroundColor: token('color.background.neutral.bold.hovered', colors.N400),
};

export const TooltipWrapper = styled.div({
  padding: token('space.100', '8px'),
});

export const ValueDifference = styled('span')<{ isImproved: boolean }>(
  ({ isImproved }) => ({
    fontWeight: 600,
    color: isImproved
      ? token('color.text.accent.green', colors.G500)
      : token('color.text.accent.red', colors.R500),
  })
);

export const SpinnerWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
});

export const MessageWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
});
